module.exports = __webpack_public_path__ + "b52fac2bb93c5858f3f2675e4b52e1de.woff2";